var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.113.583v.001a2.29 2.29 0 0 1 2.297 1.982l.007.101v4.666a1 1 0 0 1-.007.1 2.29 2.29 0 0 1-2.297 1.982v.002H11.82l-2.469 5.554a.75.75 0 0 1-.684.446 2.75 2.75 0 0 1-2.75-2.75V10.75H2.893A2.082 2.082 0 0 1 .818 8.354v-.002l.92-6A2.084 2.084 0 0 1 3.813.584zm-1.03 7.334h1.044l.143-.01a.79.79 0 0 0 .647-.645V2.737a.79.79 0 0 0-.647-.643l-.143-.01h-1.044zm-4.666 4.75a1.25 1.25 0 0 0 .8 1.164l2.366-5.322V2.083H3.805a.584.584 0 0 0-.583.496v.001l-.92 6a.583.583 0 0 0 .583.67h3.782a.75.75 0 0 1 .75.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default Svg16;